import store from '../store'

export const allowOnlyAuthorized = () => {
  return (to, from, next) => {
    const isAuthenticated = store.getters['isAuthenticated']
    if (isAuthenticated) {
      next()
    } else {
      next({name: 'login'})
    }
  }
}
